// extracted by mini-css-extract-plugin
export var Tag = "Tag-module--Tag--Bn5CW";
export var Tags = "Tag-module--Tags--1r19-";